import { render, staticRenderFns } from "./LgTableConfigCodes.vue?vue&type=template&id=17a2eb9c&scoped=true"
import script from "./LgTableConfigCodes.vue?vue&type=script&lang=js"
export * from "./LgTableConfigCodes.vue?vue&type=script&lang=js"
import style0 from "./LgTableConfigCodes.vue?vue&type=style&index=0&id=17a2eb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a2eb9c",
  null
  
)

export default component.exports